<template>
  <div class="w-full bg-black shadow-xl nav">
    <div class="flex items-center justify-between h-20 px-6 mx-auto max-w-7xl">
      <!-- Logo -->
      <div class="w-1/2 lg:w-1/4">
        <router-link :to="{ name: 'Homepage' }">
          <img src="@/assets/img/logo-light.svg" alt="Fleetbeacon" class="h-8 mr-6">
        </router-link>
      </div>
      
      <!-- Desktop Nav -->
      <nav class="justify-center flex-grow hidden w-full lg:flex">
        <router-link :to="{ name: 'Homepage' }" class="nav-link">
          Home
        </router-link>
         <flyout-menu>
          <button slot="button" type="button" class="nav-link">
            <span>Products</span>
          </button>
          <div class="relative z-20 w-screen max-w-sm mx-auto text-left bg-gray-900 rounded-lg shadow-lg hover:no-underline">
            <div class="grid items-start p-3">
              <div>
                <router-link :to="{ name: 'ProductPortal' }" class="flex items-start p-4 rounded-md hover:bg-gray-800">
                  <img src="@/assets/img/logo-portal.svg" alt="Fleetbeacon Portal" class="h-8 mr-4">
                  <div>
                    <div class="text-sm leading-tight uppercase">
                      <div class="font-bold text-white">
                        Fleetbeacon
                      </div>
                      <div class="font-medium text-cyan-500">
                        Portal
                      </div>
                    </div>
                    <div class="mt-2 text-sm leading-snug text-gray-400">
                      A suite of tools to streamline and grow your last-mile business, and enhance your customers' experience.
                    </div>
                  </div>
                </router-link>
              </div>
              <div>
                <router-link :to="{ name: 'ProductRadar' }" class="flex items-start p-4 rounded-md hover:bg-gray-800">
                  <img src="@/assets/img/logo-radar.svg" alt="Fleetbeacon Radar" class="h-8 mr-4">
                  <div>
                    <div class="text-sm leading-tight uppercase">
                      <div class="font-bold text-white">
                        Fleetbeacon
                      </div>
                      <div class="font-medium text-blue-500">
                        Radar
                      </div>
                    </div>
                    <div class="mt-2 text-sm leading-snug text-gray-400">
                      An AI-powered platform to continuously monitor your fleet and automate operations and workflows.
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </flyout-menu>
        <router-link :to="{ name: 'Pricing' }" class="nav-link">
          Pricing
        </router-link>
        <router-link :to="{ name: 'Contact' }" class="nav-link">
          Contact
        </router-link>
      </nav>

      <!-- Buttons -->
      <div class="w-1/4 ml-auto text-right">
        <router-link :to="{ name: 'Login' }" class="hidden lg:inline-flex btn btn-subtle" v-if="!$cookies.get('token')">
          Login &rarr;
        </router-link>
        <router-link v-else-if="account.subdomain" :to="{ name: 'Dashboard', params: { account: account.subdomain } }" class="hidden lg:inline-flex btn btn-subtle">
          Dashboard &rarr;
        </router-link>
        <button class="inline-flex items-center text-sm font-medium tracking-wider text-white uppercase lg:hidden" @click="showMenu = !showMenu">
          Menu <menu-icon :open="showMenu" class="ml-2 opacity-50" />
        </button>
      </div>
    </div>

    <!-- Mobile Nav -->
    <Collapse :active="showMenu" :duration="300">
      <div class="grid gap-2 px-6 pb-6 bg-black sm:grid-cols-2 lg:hidden">
        <div class="bg-gray-800 bg-opacity-25">
          <router-link :to="{ name: 'ProductPortal' }" class="flex items-start p-4 rounded-md hover:bg-gray-800">
            <img src="@/assets/img/logo-portal.svg" alt="Fleetbeacon Portal" class="h-8 mr-4">
            <div>
              <div class="text-sm leading-tight uppercase">
                <div class="font-bold text-white">
                  Fleetbeacon
                </div>
                <div class="font-medium text-cyan-500">
                  Portal
                </div>
              </div>
              <div class="mt-2 text-sm leading-snug text-gray-400">
                A suite of tools to streamline and grow your last-mile business, and enhance your customers' experience.
              </div>
            </div>
          </router-link>
        </div>
        <div class="bg-gray-800 bg-opacity-25">
          <router-link :to="{ name: 'ProductRadar' }" class="flex items-start p-4 rounded-md hover:bg-gray-800">
            <img src="@/assets/img/logo-radar.svg" alt="Fleetbeacon Radar" class="h-8 mr-4">
            <div>
              <div class="text-sm leading-tight uppercase">
                <div class="font-bold text-white">
                  Fleetbeacon
                </div>
                <div class="font-medium text-blue-500">
                  Radar
                </div>
              </div>
              <div class="mt-2 text-sm leading-snug text-gray-400">
                An AI-powered platform to continuously monitor your fleet and automate operations and workflows.
              </div>
            </div>
          </router-link>
        </div>
        <router-link :to="{ name: 'Pricing' }" class="text-center bg-gray-800 bg-opacity-25 rounded hover:bg-opacity-50 nav-link">
          Pricing
        </router-link>
        <router-link :to="{ name: 'Contact' }" class="text-center bg-gray-800 bg-opacity-25 rounded hover:bg-opacity-50 nav-link">
          Contact
        </router-link>
        <router-link :to="{ name: 'Login' }" class="text-center bg-gray-800 rounded sm:col-span-2 nav-link" v-if="!$cookies.get('token')">
          Login &rarr;
        </router-link>
        <router-link v-else-if="account.subdomain" :to="{ name: 'Dashboard', params: { account: account.subdomain } }" class="text-center bg-gray-800 rounded sm:col-span-2 hover:bg-opacity-75 nav-link">
          Dashboard &rarr;
        </router-link>
      </div>
    </Collapse>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import products from '@/store/features'

  export default {
    name: 'SiteHeader',

    computed: {
      ...mapGetters(['account'])
    },

    data () {
      return {
        products,
        showMenu: false
      }
    },

    watch: {
      '$route': {
        handler (newVal, oldVal) {
          this.showMenu = false
        }
      }
    }
  }
</script>

<style lang="postcss">
.nav {
  a {
    &:hover {
      @apply no-underline
    }
  }
}

.nav-link {
  @apply block relative py-4 text-gray-300 font-medium lg:inline-flex lg:mx-4 lg:py-2;

  &::before {
    @apply lg:absolute lg:bottom-0 lg:left-0 lg:right-0 lg:py-px lg:rounded-full lg:bg-gradient-to-r lg:from-indigo-600 lg:to-indigo-300;
    content:'';
    transform-origin:bottom right;
    transform:scaleX(0);
    transition:transform 0.5s ease;
  }

  &:hover {
    @apply text-white no-underline;

    &::before {
      transform-origin:bottom left;
      transform:scaleX(1);
    }
  }

  &.active {
    @apply text-white;
  }
}
</style>